(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ingredients-slider"] && !Shopify.designMode) return;
  try {
    
/* Load Swiper from CDN if not already loaded */
if (typeof Swiper === 'undefined') {
  var swiperScript = document.createElement('script');
  swiperScript.src = "https://unpkg.com/swiper/swiper-bundle.min.js";
  document.head.appendChild(swiperScript);

  var swiperCSS = document.createElement('link');
  swiperCSS.rel = "stylesheet";
  swiperCSS.href = "https://unpkg.com/swiper/swiper-bundle.min.css";
  document.head.appendChild(swiperCSS);

  swiperScript.onload = function() {
    initIngredientsSlider();
  };
} else {
  initIngredientsSlider();
}

function initIngredientsSlider() {
  // init all swipers in this section (tabs or no tabs)
  document.querySelectorAll('.ingredients-swiper').forEach(function(swiperEl) {
    var container = swiperEl.closest('.ingredients-swiper-container');
    var nextEl = container.querySelector('.ingredients-next');
    var prevEl = container.querySelector('.ingredients-prev');

    new Swiper(swiperEl, {
      slidesPerView: 3,
      spaceBetween: 14,
      loop: false,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      },
      breakpoints: {
        300: { slidesPerView: 1.2 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      },
      observer: true,
      observeParents: true
    });
  });

  // Tabs behaviour
  document.querySelectorAll('.ingredients-tabs').forEach(function(wrapper) {
    var buttons = wrapper.querySelectorAll('.ingredients-tab-btn');
    var panels  = wrapper.querySelectorAll('.ingredients-tab-panel');

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tab = this.dataset.tab;

        buttons.forEach(function(b) {
          b.classList.toggle('is-active', b === btn);
        });

        panels.forEach(function(panel) {
          var isActive = panel.dataset.tab === tab;
          panel.classList.toggle('is-active', isActive);

          if (isActive) {
            var sw = panel.querySelector('.ingredients-swiper');
            if (sw && sw.swiper) {
              sw.swiper.update();
            }
          }
        });
      });
    });
  });
}

  } catch(e) { console.error(e); }
})();
})();
